import { render, staticRenderFns } from "./LayoutBase.vue?vue&type=template&id=326e21d0&scoped=true&"
import script from "./LayoutBase.vue?vue&type=script&lang=ts&"
export * from "./LayoutBase.vue?vue&type=script&lang=ts&"
import style0 from "./LayoutBase.vue?vue&type=style&index=0&id=326e21d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "326e21d0",
  null
  
)

export default component.exports